export default __webpack_public_path__ + "static/media/Raion5.68e89206.png";